/**
 * On Range Long Game Reducers
 */
import {
    ORTLONGGAME_ACTION,
    ALL_ORTLONGGAME,
    ADD_ORTLONGGAME,
    FETCH_ORTLONGGAME,
    EDIT_ORTLONGGAME,
    DELETE_ORTLONGGAME,
    FETCH_ORTLONGGAMECHART,
    FETCH_ORTLONGGAMESHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    ortlonggamelist:[],
    particularortlonggame:[],  
    ortlonggamechart:[],
    ortlonggameshotchart:[],   
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case ORTLONGGAME_ACTION:
            return { ...state, loading: true };       

        case ALL_ORTLONGGAME:
            return { ...state, loading: false, ortlonggamelist: action.payload };     
            
        case ADD_ORTLONGGAME:
            return { ...state, loading: false };     
         
        case FETCH_ORTLONGGAME:
            return { ...state, loading: false, particularortlonggame: action.payload };  
            
        case EDIT_ORTLONGGAME:
            return { ...state, loading: false }; 
            
        case DELETE_ORTLONGGAME:
            return { ...state, loading: false };     

        case FETCH_ORTLONGGAMECHART:
            return { ...state, loading: false, ortlonggamechart: action.payload }; 
            
        case FETCH_ORTLONGGAMESHOTCHART:
            return { ...state, loading: false, ortlonggameshotchart: action.payload }; 
        
        default: return { ...state };

     }
 }